import { render, staticRenderFns } from "./Prizes.vue?vue&type=template&id=d30ee92e&scoped=true&"
import script from "./Prizes.vue?vue&type=script&lang=js&"
export * from "./Prizes.vue?vue&type=script&lang=js&"
import style0 from "./Prizes.vue?vue&type=style&index=0&id=d30ee92e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d30ee92e",
  null
  
)

export default component.exports